/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPaginatedListOfLedgerSummaryFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeCreateLedgerCommand, type CreateLedgerCommand, type PaginatedListOfLedgerSummary, type ProblemDetails } from '../models/index.js';
// @ts-ignore
import { LedgersItemRequestBuilderNavigationMetadata, LedgersItemRequestBuilderRequestsMetadata, type LedgersItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /ledgers
 */
export interface LedgersRequestBuilder extends BaseRequestBuilder<LedgersRequestBuilder> {
    /**
     * Gets an item from the ApiSdk.ledgers.item collection
     * @param id Unique identifier of the item
     * @returns {LedgersItemRequestBuilder}
     */
     byId(id: Guid) : LedgersItemRequestBuilder;
    /**
     * GetLedgers
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedListOfLedgerSummary>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<LedgersRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedListOfLedgerSummary | undefined>;
    /**
     * CreateLedger
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Guid>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: CreateLedgerCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Guid | undefined>;
    /**
     * GetLedgers
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<LedgersRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * CreateLedger
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateLedgerCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * GetLedgers
 */
export interface LedgersRequestBuilderGetQueryParameters {
    criteria?: string;
    pageNumber?: number;
    pageSize?: number;
    sortExpression?: string;
}
/**
 * Uri template for the request builder.
 */
export const LedgersRequestBuilderUriTemplate = "{+baseurl}/ledgers{?Criteria*,PageNumber*,PageSize*,SortExpression*}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const LedgersRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "criteria": "Criteria",
    "pageNumber": "PageNumber",
    "pageSize": "PageSize",
    "sortExpression": "SortExpression",
};
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const LedgersRequestBuilderNavigationMetadata: Record<Exclude<keyof LedgersRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        requestsMetadata: LedgersItemRequestBuilderRequestsMetadata,
        navigationMetadata: LedgersItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["id"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const LedgersRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: LedgersRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedListOfLedgerSummaryFromDiscriminatorValue,
        queryParametersMapper: LedgersRequestBuilderGetQueryParametersMapper,
    },
    post: {
        uriTemplate: LedgersRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "string",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateLedgerCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
